/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import {
  Grid,
  Header,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

const steps = [
  {
    icon: 'Verify',
    title: 'Verification',
    description: 'Consent form and verification for purchaser to e-sign',
  },
  {
    icon: 'IC',
    title: 'Photo of IC',
    description: 'IC Front and Back',
  },
  {
    icon: 'income_new',
    title: 'Purchaser\'s Income',
    description: 'Input either basic or detailed income',
  },
];

const CreditCheckSplash = ({ actionNode }) => (
  <Grid stackable doubling textAlign="center">
    <Grid.Row columns={4}>
      {
        steps.map((step, idx) => (
          <Grid.Column key={idx}>
            <Header as="h3" icon style={{ color: '#00233B' }}>
              <i className="green circular inverted icon">
                <img src={`/assets/images/icons/${step.icon}.svg`} alt="" />
              </i>
              {idx + 1}. {step.title}
              <Header as="h5" style={{ color: 'rgba(0, 35, 59, 0.9)', marginTop: 0 }}>
                {step.description}
              </Header>
            </Header>
          </Grid.Column>
        ))
      }
    </Grid.Row>
    <Grid.Row style={{ padding: '1rem' }}>
      <Header
        as="h5"
        style={{ color: 'rgba(114, 140, 152, 1)', fontWeight: 'normal' }}
      >
        If Purchaser is not available to e-sign, you may <a className="consentLink" href="https://mhub.my/consent/credit_check/" target="_blank">download the Consent Form</a><br />
        to send it over to the Puchaser and get them to send signed copy to you.
      </Header>
    </Grid.Row>
    {actionNode}
  </Grid>
);

CreditCheckSplash.propTypes = {
  actionNode: PropTypes.node,
};

export default CreditCheckSplash;



// WEBPACK FOOTER //
// ./src/components/NewCreditCheckSplash.jsx